import mbc from "../functions/mbc";

interface SyncStorage {
	getItem(key: string, initialValue?: any): any;
	setItem(key: string, newValue: any): void;
	removeItem(key: string): void;
	entries(): Array<[key: string, value: any]>;
}

class MbcStorage implements SyncStorage {
	storage: object;

	constructor(data: object) {
		this.storage = data ?? {};
	}

	getItem<T = any>(key: string, initialValue?: T): T | undefined {
		if (!Object.hasOwn(this.storage, key)) return initialValue;
		return this.storage[key];
	}

	removeItem(key: string): void {
		delete this.storage[key];
	}

	setItem<T = any>(key: string, value: T): void {
		this.storage[key] = value;
	}

	entries(): Array<[key: string, value: any]> {
		return Object.entries(this.storage);
	}
}
export const mbcStorage = new MbcStorage(mbc.getInitialState().storage);

export const serializeDeserialize = (data: any) => data;
